module.exports = __webpack_public_path__ + "media/18.182d03e3.mp3";